export default __webpack_public_path__ + "static/media/quanphu.24c5b474.png";